module.exports = __webpack_public_path__ + "static/favonius-lance-f3c68c8d387a88f27ffc4a976d45450c.png";